import React, { useEffect, useRef } from "react";

export function TrackHeight({setSize, windowSize, children}) {
    const refContainer = useRef();
    useEffect(() => {
        if (refContainer.current) {
            setSize(refContainer.current.offsetHeight);
        }
    }, [windowSize, setSize]);

    return(
        <div ref={refContainer}>
            {children}
        </div>
    )
}

export function TrackWidth({setSize, windowSize, children}) {
    const refContainer = useRef();
    useEffect(() => {
        if (refContainer.current) {
            setSize(refContainer.current.offsetWidth);
        }
    }, [windowSize, setSize]);

    return(
        <div ref={refContainer}>
            {children}
        </div>
    )
}